"use client";

import React from "react";
import { CircleAlert as AlertCircle, ShieldAlert, FileText } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
export default function RiderRules() {
  const shouldReduceMotion = useReducedMotion();
  const easeCurve = [0.16, 1, 0.3, 1] as const;
  return <section id="riderrulesguidance" data-nav="light" className="w-full bg-background text-foreground py-16 md:py-24 border-b border-border">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: shouldReduceMotion ? 0 : 0.3,
        ease: easeCurve
      }} className="relative bg-card text-card-foreground border border-border p-6 sm:p-10 shadow-xs">
          {/* Industrial Plate Decorative Corner Notches */}
          <div className="absolute top-0 left-0 w-2.5 h-2.5 border-t-2 border-l-2 border-primary -translate-x-px -translate-y-px pointer-events-none" />
          <div className="absolute top-0 right-0 w-2.5 h-2.5 border-t-2 border-r-2 border-primary translate-x-px -translate-y-px pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-2.5 h-2.5 border-b-2 border-l-2 border-primary -translate-x-px translate-y-px pointer-events-none" />
          <div className="absolute bottom-0 right-0 w-2.5 h-2.5 border-b-2 border-r-2 border-primary translate-x-px translate-y-px pointer-events-none" />

          {/* Header Metadata Bar */}
          <div className="flex flex-wrap items-center justify-between gap-3 pb-6 border-b border-border">
            <div className="flex items-center gap-2">
              <ShieldAlert className="size-4 text-primary shrink-0" />
              <span className="font-mono text-xs font-semibold tracking-wider text-muted-foreground uppercase">
                OPERATIONAL COMPLIANCE &amp; SAFETY
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-mono text-[11px] text-muted-foreground bg-muted px-2 py-0.5 border border-border">
                SPEC-DOC REF: ADVISORY-PLATE
              </span>
            </div>
          </div>

          {/* Section Heading */}
          <div className="pt-6 pb-6">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight text-foreground font-default">
              Follow the Rider Rules for the Exact Mechanical Bull
            </h2>
          </div>

          {/* Body Content Blocks */}
          <div className="space-y-4 text-base sm:text-lg leading-relaxed text-muted-foreground">
            <div className="flex items-start gap-3">
              <FileText className="size-5 text-primary shrink-0 mt-1" />
              <p>
                Rider limitations and operating rules can differ between machines.
                Therefore, use the requirements stated in the documentation for
                the exact equipment rather than applying one universal age,
                height or weight limit.
              </p>
            </div>

            <div className="flex items-start gap-3">
              <div className="size-5 flex items-center justify-center shrink-0 mt-1">
                <span className="block size-1.5 bg-primary" />
              </div>
              <p>
                The operator should also understand any product-specific
                instructions about clothing, footwear, mounting, dismounting and
                use of the inflatable safety area.
              </p>
            </div>
          </div>

          {/* Highlighted Advisory Callout Plate */}
          <div className="mt-8 border-l-2 border-primary bg-muted/50 p-4 sm:p-5 flex items-start gap-3.5">
            <AlertCircle className="size-5 text-primary shrink-0 mt-0.5" />
            <div className="space-y-1">
              <span className="font-mono text-xs uppercase tracking-wider font-semibold text-foreground block">
                Operator Mandate
              </span>
              <p className="text-foreground font-medium text-base sm:text-lg leading-snug">
                If a requirement is unclear, confirm it before operating the
                machine.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}